__turbopack_context__.v({
  "label": "SortSelect-module-scss-module__n67uJa__label",
  "select": "SortSelect-module-scss-module__n67uJa__select",
  "sortSelect": "SortSelect-module-scss-module__n67uJa__sortSelect",
});
